export default {
  allMitigationGroups: (state) => state.mitigationGroups,
  mitigationGroupsLoading: (state) => state.loading
}
